export class MajorLocation {
    constructor(major_location?: string, major_loc_id?: string) {
        this.major_location = major_location;
        this.major_loc_id = major_loc_id;
    }

    major_location: string;
    major_loc_id: string;
}